'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaListOl = function FaListOl(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.5 36.2q0 1.7-1.2 2.8t-3 1q-2.4 0-3.9-1.5l1.3-1.9q1.1 1 2.4 1 0.6 0 1.1-0.4t0.5-0.9q0-1.4-2.4-1.3l-0.6-1.2q0.2-0.2 0.8-1t0.9-1.2 0.8-0.8v-0.1q-0.3 0-1 0.1t-1.1 0v1.2h-2.4v-3.4h7.4v1.9l-2.1 2.6q1.2 0.3 1.8 1.1t0.7 2z m0-14v3.5h-8q-0.2-0.8-0.2-1.2 0-1.1 0.6-2.1t1.2-1.5 1.5-1 1.3-1 0.5-1q0-0.6-0.3-0.9t-0.9-0.3q-1.1 0-1.8 1.3l-1.9-1.3q0.5-1.1 1.6-1.8t2.3-0.6q1.6 0 2.8 0.9t1.1 2.5q0 1.1-0.8 2.1t-1.7 1.4-1.6 1.1-0.8 1.2h2.8v-1.3h2.4z m31.5 7.1v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z m-31.4-20.1v2.2h-7.5v-2.2h2.4q0-0.9 0-2.7t0-2.7v-0.3h0q-0.2 0.4-1.2 1.2l-1.5-1.7 3-2.8h2.4v9h2.4z m31.4 8.7v4.2q0 0.3-0.2 0.5t-0.5 0.3h-27.2q-0.2 0-0.5-0.3t-0.2-0.5v-4.2q0-0.4 0.2-0.6t0.5-0.2h27.2q0.3 0 0.5 0.3t0.2 0.5z m0-11.5v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaListOl;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/list-ol.js
// module id = 1828
// module chunks = 168707334958949